export default __webpack_public_path__ + "static/media/harness_of_ferine_anger.a9c1cfa1.jpg";